export interface CreateSupplierPayload {
  custom_code: string;
  title: string;
  first_name: string;
  last_name: string;
  gender: string;
  mobile: string;
  email: string;
  whatsapp_number: string;
  website_url: string;

  agency_name: string;
  address: string;
  country_id: string;
  state_id: string;
  city_id: string;
  pincode: string;

  password: string;

  status: "pending"; 
  inventory_status: "active";
  supplier_docs: SupplierDocument[];
  bank_details: BankDetail[];
}

export interface SupplierDocument {
  doc_type:
    | "pan_card"
    | "gst_certificate"
    | "aadhar_card"
    | "voter_id_card"
    | "driving_licence"
    | "passport"
    | "bank_passbook"
    | "cancelled_cheque";
  doc_url: string;
  doc_name: string;
  doc_number: string;
}

export interface BankDetail {
  account_holder_name: string;
  account_number: string;
  bank_name: string;
  branch_name: string;
  account_type: "savings" | "current"; //| "cash_credit"| "overdraft";
  ifsc_code: string;
  is_primary: true;
}

export const BANK_TYPES = ["savings", "current"] as const; //| "cash_credit"| "overdraft";

export type BankType = typeof BANK_TYPES[number];